import { useNavigate } from 'react-router-dom'

/**
 * Помощь — веб-версия текста util_sys_help (app/handlers/navigation.py).
 *
 * Справка ДОПОЛНЯЕТ главный экран, а не пересказывает его: там «куда идти»,
 * здесь «как проходит занятие». Разделы (Теория / Решение задач / Цель)
 * заново не перечисляются; режимы, скрытые настройкой показа (§2.16), не
 * упоминаются: обещать кнопку, которой нет на экране, нельзя. Команды /start, /goal, /help
 * заменены кнопками: в вебе нет командной строки.
 */
export default function Help() {
  const navigate = useNavigate()

  return (
    <>
      <h1>❓ Помощь</h1>

      <p><b>Как проходит занятие</b></p>
      <ul style={{ paddingLeft: 20, margin: '0 0 16px' }}>
        <li>Ответ пришли текстом, числом или фото — проверю и разберу ошибку.</li>
        <li>
          Не выходит — жми <b>🤝 Решаем вместе</b>: доведу по шагам, но решать будешь ты.
        </li>
        <li>
          Задача с развёрнутым решением — <b>📝 Сдать решение</b>: оценю ход по
          критериям экзамена, как на проверке.
        </li>
        <li>Любой вопрос можно просто написать в чат, а условие — прислать фотографией.</li>
      </ul>

      <p><b>ОГЭ или ЕГЭ</b></p>
      <p style={{ margin: '0 0 16px' }}>
        Экзамен выбираешь ты — и в любой момент меняешь в «🎯 Цель и прогресс». Задачи,
        цель и баллы будут по нему.
      </p>

      <p>Про очки, уровни и значки — «📜 Правила».</p>

      <div className="row-wrap" style={{ marginTop: 16 }}>
        <button className="btn" onClick={() => navigate('/achievements?from=help')}>🏆 Достижения</button>
        <button className="btn" onClick={() => navigate('/rules')}>📜 Правила</button>
        <button className="btn" onClick={() => navigate('/')}>🏠 Главная</button>
      </div>
    </>
  )
}
